export const SAVE_SETTINGS = 'SAVE_SETTINGS'
export const SET_STAY_SIGNED = 'SET_STAY_SIGNED'
